// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5":"2d8cac6a","2232":"145bfb5b"}[chunkId] || chunkId) + "." + {"5":"ba94e4fa2da9419c","2232":"fa7a58eaf50da337","4384":"63f4ce82a859591b","5973":"d9a3567429734c06","8559":"54bed5c6d3f848ef"}[chunkId] + ".js";
};